// FE-only vocabulary for the Business tab: status labels + row explanations
// (BLOCK 4.1 / §13), status-group → CSS-Module class name, StatusScale fill
// percentage (mirrors legacy Enrollments StatusScale.js), match-type labels.
// The API sends raw tokens — this file maps them to what the merchant reads.

export const STATUS_META = {
  active: {
    label: "Active",
    group: "active",
    explanation:
      "The descriptor is successfully enrolled. Your purchase details are now shared with issuing banks to prevent disputes."
  },
  pending: {
    label: "Pending",
    group: "pending",
    explanation:
      "Enrollment is being processed. No action needed — we'll update the status once it's active."
  },
  in_re_enrollment: {
    label: "In Re-enrollment",
    group: "pending",
    explanation:
      "Your enrollment is being processed. No action needed — we'll update the status once it's active."
  },
  in_progress: {
    label: "In Progress",
    group: "pending",
    explanation:
      "Enrollment is ongoing but not finalized yet. No action needed — we'll update the status once it's active."
  },
  pending_unenroll: {
    label: "Pending Unenroll",
    group: "pending",
    explanation: "This descriptor is being unenrolled. We'll update the status once it's complete."
  },
  verification_needed: {
    label: "Verification Needed",
    group: "pending",
    explanation: "Manual verification is needed before activation. Our team will review it shortly."
  },
  needs_assistance: {
    label: "Needs Assistance",
    group: "needs_help",
    explanation:
      "ARN/BIN/CAID codes are required to complete enrollment. Please add them to continue."
  },
  unenrolled: {
    label: "Unenrolled",
    group: "unenrolled",
    explanation:
      "The descriptor has been removed from the enrollment and no longer deflects disputes."
  },
  enrolled_elsewhere: {
    label: "Enrolled Elsewhere",
    group: "failed",
    explanation:
      "The descriptor is already in use elsewhere and can't be enrolled. Remove it from the other service or contact support."
  },
  generic_descriptor: {
    label: "Generic Descriptor",
    group: "failed",
    explanation:
      "The descriptor is too broad or non-specific to be enrolled. Please use a more specific billing descriptor."
  },
  banned_descriptor: {
    label: "Banned Descriptor",
    group: "failed",
    explanation: "The descriptor is not allowed due to policy restrictions."
  },
  invalid_descriptor: {
    label: "Invalid Descriptor",
    group: "failed",
    explanation:
      "The descriptor is not usable or has been flagged as incorrect. Please review and re-add it."
  },
  invalid_codes: {
    label: "Invalid ARN/BIN/CAID",
    group: "failed",
    explanation: "The provided ARN/BIN/CAID codes are invalid. Please review and re-add them."
  }
}

// status_group → CSS-Module class suffix + program-card chip label
// (BLOCK 2 of CHA1-1967). The chip label is per-group, so it can't come
// from STATUS_META which is keyed by descriptor status.
export const GROUP_META = {
  active: { class: "stActive", label: "Active" },
  pending: { class: "stPending", label: "Pending" },
  needs_help: { class: "stNeedsHelp", label: "Needs Help" },
  failed: { class: "stFailed", label: "Failed" },
  unenrolled: { class: "stUnenrolled", label: "Unenrolled" },
  not_enrolled: { class: "stNotEnrolled", label: "Not enrolled" }
}

// Fill percentage for the StatusScale-style underline. Mirrors legacy
// ConfigurePage/Enrollments/components/StatusScale/StatusScale.js — same
// numbers so the two surfaces read the same at a glance.
export const STATUS_PERCENTAGE = {
  active: 100,
  pending: 25,
  in_re_enrollment: 25,
  in_progress: 50,
  pending_unenroll: 75,
  verification_needed: 75,
  needs_assistance: 10,
  unenrolled: 100,
  enrolled_elsewhere: 50,
  generic_descriptor: 50,
  banned_descriptor: 50,
  invalid_descriptor: 50,
  invalid_codes: 50
}

export const MATCH_TYPE_LABEL = {
  exact: "Exact match",
  starts_with: "Starts with"
}

// Support's Order Insight codes-view toggle (CHA1-1975 BLOCK 5). The right panel
// cycles through the descriptor list and whichever code views this BA has; the
// code-view keys are the server's `available_code_types` / `code_type` values.
export const CODES_VIEW = {
  DESCRIPTORS: "descriptors",
  ARN: "arn",
  BIN_CAID: "bin_caid"
}

// The link never names the view it is on — it names the one a click moves to.
export const CODES_VIEW_LINK_LABEL = {
  [CODES_VIEW.DESCRIPTORS]: "Show descriptors",
  [CODES_VIEW.ARN]: "Show ARN codes",
  [CODES_VIEW.BIN_CAID]: "Show BIN & CAID codes"
}
